import * as React from 'react'
import * as PopoverPrimitive from '@radix-ui/react-popover'

import { cn } from '@/lib/utils'

const Popover = PopoverPrimitive.Root

const PopoverTrigger = PopoverPrimitive.Trigger

const PopoverAnchor = PopoverPrimitive.Anchor

const PopoverContent = React.forwardRef<
  React.ElementRef<typeof PopoverPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Content>
>(({ className, align = 'end', sideOffset = 6, ...props }, ref) => (
  <PopoverPrimitive.Portal>
    <PopoverPrimitive.Content
      ref={ref}
      align={align}
      sideOffset={sideOffset}
      className={cn(
        'z-50 w-72 rounded-lg border bg-popover p-4 text-popover-foreground shadow-elevation-2 outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2',
        className,
      )}
      {...props}
    />
  </PopoverPrimitive.Portal>
))
PopoverContent.displayName = PopoverPrimitive.Content.displayName

// #289 — a hover card: the shared hover surface and motion (index.css) instead of the click
// popover's look, and an arrow at its item. Timing comes from useHoverIntent.
const HoverCardContent = React.forwardRef<
  React.ElementRef<typeof PopoverPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Content> & { instant?: boolean }
>(({ className, children, instant, ...props }, ref) => (
  <PopoverPrimitive.Portal>
    <PopoverPrimitive.Content
      ref={ref}
      data-instant={instant ? '' : undefined}
      className={cn('z-50 outline-none hover-surface hover-motion', className)}
      {...props}
    >
      {children}
      {/* Radix places and turns this box (12 x 6) at the item; the square inside it is the arrow */}
      <PopoverPrimitive.Arrow asChild width={12} height={6}>
        <span data-hover-arrow className="relative block h-1.5 w-3">
          {/* centred on the card's edge: the inner half hides in the card, the outer half points */}
          <span className="hover-arrow -top-1.5 left-0 border-b border-r" />
        </span>
      </PopoverPrimitive.Arrow>
    </PopoverPrimitive.Content>
  </PopoverPrimitive.Portal>
))
HoverCardContent.displayName = 'HoverCardContent'

export { Popover, PopoverTrigger, PopoverContent, PopoverAnchor, HoverCardContent }
